
export default class Videos {

	constructor(selector = '.js-autopause-video', options = {}) {

		this.selector = selector;
		this.videos = [];
		this.observer = null;

		this.options = Object.assign({
			threshold: 0.3
		}, options);

	}

	/*
	** load
	*/

	load() {

		this.videos = document.querySelectorAll(this.selector);

		this.observer = new IntersectionObserver((entries) => {

			entries.forEach(entry => {

				const video = entry.target;

				if (entry.isIntersecting) 
				{
					video.play();
				}
				 else
				{
					video.pause();
				}

			});

		}, {
			threshold: this.options.threshold
		});

		this.videos.forEach(video => {
			this.observer.observe(video);
		});

	}

	/*
	** unload
	*/

	unload() {

		if (this.videos && this.observer)
		{
			this.videos.forEach(video => {
				this.observer.unobserve(video);
				video.pause();
			});

		}

		if (this.observer)
		{
			this.observer.disconnect();
			this.observer = null;
		}

		this.videos = [];
	}

}